import { config } from '../../config';
import { updateSystemSettings } from '../../services/config/admin/LocalConfigParam';

export const sessionChecker = resp => {
  if (
    (resp.respCode && resp.respCode !== 0) ||
    (resp.statusCode && resp.statusCode !== 0) ||
    (resp.status && resp.status !== 0)
  ) {
    if (
      resp.respCode === config.httpStatusCodes.UNAUTHORIZED ||
      resp.statusCode === config.httpStatusCodes.UNAUTHORIZED ||
      resp.status === config.httpStatusCodes.UNAUTHORIZED
    ) {
      localStorage.removeItem(config.jwtTokenStoreName);
      localStorage.removeItem(config.localUserDTO);

      if (!document.location.href.endsWith('/user/signin')) {
        document.location.href =
          config.appURL +
          config.react_routes.prefix +
          config.react_routes.modules.user.prefix +
          config.react_routes.modules.user.services.signin;
      }

      return config.httpStatusCodes.UNAUTHORIZED;
    } else if (
      resp.respCode === config.httpStatusCodes.FORBIDDEN ||
      resp.status === config.httpStatusCodes.FORBIDDEN
    ) {
      // document.location.href = '/user/forbidden';
      return config.httpStatusCodes.FORBIDDEN;
    }
  } else {
    if (resp.data && resp.data.token) {
      console.log('updating token');
      localStorage.setItem(config.jwtTokenStoreName, resp.data.token);
    }
    if (resp.data && resp.data.systemSettings) {
      console.log('updating system settings');
      updateSystemSettings(resp.data.systemSettings);
    }
    return config.httpStatusCodes.OK;
  }
};

export const sessionCloser = resp => {
  return new Promise(async (resolve, reject) => {
    localStorage.removeItem(config.jwtTokenStoreName);
    localStorage.removeItem(config.localUserDTO);
    resolve({
      respCode: config.httpStatusCodes.UNAUTHORIZED,
      message:
        'No ha iniciado sesión por lo tanto no puede ingresar a esta opción',
    });
  });
};

export const getStoredToken = () => {
  const token = localStorage.getItem(config.jwtTokenStoreName);
  if (token) {
    //return JSON.parse(token);
    return token;
  } else {
    return null;
  }
};
